import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { documentTypes, clientTypes } from './create-client-data';
import { createClient } from '../../actions/client-actions';
import { Link, useNavigate  } from 'react-router-dom';
import { provinces } from '../../actions/global-actions-data';

function CreateClient(){
    const currentLink = "/clientes";
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.user.user);

    const [form, setForm] = useState({
        firstName: '',
        lastName: '',
        documentType: 'CC',
        document: '',
        email: '',
        clientType: 'natural',
        manager: '',
        managerDocumentType: 'CC',
        managerDocument: '',
        managerEmail: '',
        province: '',
        city: '',
    });
    const [citiesData, setCitiesData] = useState([]);

    const handleInputChange = (event) => {
        if (event.target.name === 'clientType' && event.target.value === 'juridica') {
            setForm({
                ...form,
                manager: '',
                managerDocumentType: 'CC',
                managerDocument: '',
                managerEmail: '',
                [event.target.name] :  event.target.value
            })
        } else {
            setForm({
                ...form,
                [event.target.name] :  event.target.value
            })
        }

    }

    const handleOnChange = (event) => {
        const value = event.target.value;
        if (value !== '' && value) {
            const cities = provinces.find( x => x.name === value).cities;
            setCitiesData(cities);
            setForm({
                ...form,
                [event.target.name]: event.target.value
            })
            return;
        }

        setCitiesData([])
        setForm({
            ...form,
            city :  '',
            province: ''
        })
    }

    const validateFields = () => {
        if (form.clientType === '') return true;

        if (form.clientType === 'natural') {
            for (const field in form) {
                if (form.hasOwnProperty(field)) {
                    //console.log(`${field}: ${form[field]}`);
                    if ( field !== 'manager' && field !== 'managerDocumentType' && field !== 'managerDocument' && field !== 'managerEmail' && form[field] === '') {
                        return true
                    }
                }
            }
        } else {
            for (const field in form) {
                if (form.hasOwnProperty(field)) {
                    //console.log(`${field}: ${form[field]}`);
                    if ( form[field] === '' ) {
                        return true
                    }
                }
            }
        }
        return false
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar todos los datos para continuar",
            });
            return;
        } else {
            let newObj = {
                ...form
            };

            if (newObj.clientType === 'natural') {
                delete newObj.manager;
                delete newObj.managerDocumentType;
                delete newObj.managerDocument;
                delete newObj.managerEmail;
            }

            dispatch( createClient( newObj, createFunction, user.token ) );
        }
    }

    const createFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            navigate(currentLink)
            //console.log(data);
            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Cliente creado con éxito"
            });
        }
    }

    useEffect(() => {
        //console.log(form)
    }, [form]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Nuevo cliente</h1>
                <form onSubmit={handleOnSubmit}>
                    <div className="d-flex w-100 flex-wrap">
                        <h4 className="w-100 mb-2">Datos generales</h4>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="firstName">Nombres</label>
                            <input id="firstName" name="firstName" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange}></input>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="lastName">Apellidos</label>
                            <input id="lastName" name="lastName" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange}></input>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="documentType">Tipo de documento</label>
                            <select className="input-field" id="documentType" name="documentType" onChange={handleInputChange} value={form.documentType}>
                                <option></option>
                                {documentTypes.map((documentType, index) => (
                                    <option key={index} value={documentType.value}>{documentType.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="document">Documento</label>
                            <input id="document" name="document" autoComplete="off"  maxLength={15} className="input-field" type="number" onChange={handleInputChange}></input>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="email">Email</label>
                            <input id="email" name="email" autoComplete="off" maxLength={120} className="input-field" type="email" onChange={handleInputChange}></input>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="clientType">Tipo de cliente</label>
                            <select className="input-field" id="clientType" name="clientType" onChange={handleInputChange} value={form.clientType}>
                                <option></option>
                                {clientTypes.map((clientType) => (
                                    <option key={clientType.value} value={clientType.value}>{clientType.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="province">Departamento de residencia</label>
                            <select className="input-field" id="province" name="province" onChange={handleOnChange}>
                                <option></option>
                                {provinces.map((province) => (
                                    <option key={province.name} value={province.name}>{province.name}</option>
                                ))}
                            </select>
                        </div>
                        {form.province !== '' && citiesData && citiesData !== [] ? 
                            <div className="d-flex flex-column w-3 field">
                                <label className="label-field" htmlFor="city">Ciudad de residencia</label>
                                <select className="input-field" id="city" name="city" onChange={handleInputChange}>
                                    <option></option>
                                    {citiesData.map((city) => (
                                        <option key={city.name} value={city.name}>{city.name}</option>
                                    ))}
                                </select>
                            </div>
                            :''}
                        {form.clientType === 'juridica' ? 
                            <div className="d-flex w-100 flex-wrap">
                                <h4 className="w-100 mb-2">Representante legal</h4>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="manager">Representante</label>
                                    <input id="manager" name="manager" autoComplete="off" maxLength={200} className="input-field" type="text" onChange={handleInputChange}></input>
                                </div>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="managerDocumentType">Tipo de documento</label>
                                    <select className="input-field" id="managerDocumentType" name="managerDocumentType" onChange={handleInputChange} value={form.managerDocumentType}>
                                        <option></option>
                                        {documentTypes.map((documentType, index) => (
                                            <option key={index} value={documentType.value}>{documentType.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="managerDocument">Documento</label>
                                    <input id="managerDocument" name="managerDocument" autoComplete="off" maxLength={100} className="input-field" type="number" onChange={handleInputChange}></input>
                                </div>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="managerEmail">Email</label>
                                    <input id="managerEmail" name="managerEmail" autoComplete="off" maxLength={120} className="input-field" type="email" onChange={handleInputChange}></input>
                                </div>
                            </div>
                         : ''}
                        <div className="w-100 d-flex d-flex justify-content-center my-4">
                            <button className="primary-button save-button" type="submit">Guardar &#43;</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreateClient;
  